<template>
  <router-view />
</template>

<script>

export default {
  name: 'ProposalWrapper'
}
</script>
